import { useCallback } from 'react';
import { useFilterChangeCallback } from 'shared/hooks';
import { FILTER_KEY } from '../constants';

const DEFAULT_VALUE = 1;

export const useBedsChangeHandler = () => {
  const onChange = useFilterChangeCallback(FILTER_KEY);

  return useCallback(
    (value: number) => {
      const gte = value > DEFAULT_VALUE ? value : null;

      onChange({ action: 'setBeds', arguments: [gte, null] });
    },
    [onChange],
  );
};
